import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC0K73XjOZ3Jo_urHOmosZG5FB874-35iw",
  authDomain: "ehon-inc-app.firebaseapp.com",
  projectId: "ehon-inc-app",
  storageBucket: "ehon-inc-app.appspot.com",
  messagingSenderId: "487617146862",
  appId: "1:487617146862:web:9e16141603e3c7ba19a8ff",
  measurementId: "G-D18XENE8LP"
};


firebase.initializeApp(firebaseConfig);

export default firebase;